// Create analytics context with some default values
import React from "react";

import analyticsService, { AnalyticsService } from "@app/util/analytic/AnalyticsService";

const AnalyticsContext = React.createContext<AnalyticsService>(analyticsService);

export default AnalyticsContext;
